




























import Vue, { PropType } from 'vue';
import { Pricing as PricingType } from '../../module/Deals/view/vue/domain/Pricing';
import Pricing from '../../frontend/components/Pricing.vue';

type ListViewItem = {
  unique: string;
  description: string;
  secondLine: string | null;
  isPurchasable: boolean;
  stats: {
    discount: string;
    sales: string;
  };
  pricing: PricingType;
};

export default Vue.extend({
  components: { Pricing },
  props: {
    items: {
      type: Array as PropType<ListViewItem[]>,
      required: true,
    },
  },
  methods: {
    select(item: ListViewItem) {
      this.$emit('select', item);
    },
  },
});
